import React, { useEffect, useRef } from "react";
import './VideoChat.css';

interface IVideoChatProps{
    videoUrl?: string;
    selectedTime: number;
}

export const VideoChat = ({videoUrl, selectedTime}: IVideoChatProps)=>{
    const videoRef = useRef<HTMLVideoElement>(null);
    useEffect(()=>{
        if (!videoRef.current){
            return;
        }
        videoRef.current.currentTime = selectedTime;
    }, [selectedTime, videoRef.current]);

    return <div className={`videoChat`}>
        <div className="videoChat_videos">
            <div className="videoChat_video">
                <video ref={videoRef} className="videoChat_video_element" src={videoUrl || null}></video>
            </div>
            <div className="videoChat_video_opponent">
                
            </div>
        </div>
        <div className="videoChat_controls">
            <div className="videoChat_controls_left">
                <div className="button videoChat_control videoChat_control_volume">
                </div>
            </div>
            <div className="videoChat_controls_center">
                <div className="button videoChat_control videoChat_control_screen">
                </div>
                <div className="button videoChat_control videoChat_control_mic">
                </div>
                <div className="button videoChat_control videoChat_control_close">
                </div>
                <div className="button videoChat_control videoChat_control_camera">
                </div>
                <div className="button videoChat_control videoChat_control_setting">
                </div>
            </div>
            <div className="videoChat_controls_right">
                <div className="button videoChat_control videoChat_control_expand">
                </div>
            </div>
        </div>
    </div>
}